import { useReducer } from "react";
import TenantContext from "./TenantContext";
import TenantReducer from "./TenantReducer";

import {
  BASICSHARED_LOADED,
  DEMO_TENANT,
  FULLSHARED_LOADED,
  KYC_DATA_FAILED,
  KYC_DATA_LOADED,
  KYC_FAILED,
  KYC_SUCCESS,
  PAYMENT_SCORE_FAILED,
  PAYMENT_SCORE_SUCCESS,
  PREVIOUS_RENTED_PROPERTY_LOADED,
  RENTED_PROPERTY_LOADED,
  TOGGLE_LOADING,
} from "../types";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../hooks/useTranslator";
import { haveValue, toast } from "../../helper/common";
import axiosInstance from "../../services/authWrapper";
import axios from "axios";

const TenantState = (props) => {
  const { _t } = useTranslator();

  const initialState = {
    kycuserinfo: {},
    fullProfileShared: [],
    fullProfileSharedLoaded: false,
    basicProfileShared: [],
    rentedProperties: [],
    previouslyRentedProperties: [],
    loadingTenant: "loading tenant",
    isLoading: false,
    isError: true,
    kyc_done: false,
    paymentInfoError: null,
    paymentInfo: null,
  };

  const [state, dispatch] = useReducer(TenantReducer, initialState);

  const demoFun = () => {
    toast.success(_t("tenantContextFunIsClicked"));
    dispatch({
      type: DEMO_TENANT,
      payload: "this is payload",
    });
  };

  const setLoading = (value) => {
    dispatch({
      type: TOGGLE_LOADING,
      payload: value,
    });
  };

  const getKycInfo = async (tenantid, verificationid) => {
    setLoading(true);
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/kyc/${tenantid}/${verificationid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        let serverResponse = res;
        dispatch({
          type: KYC_DATA_LOADED,
          payload: serverResponse.data,
        });
      })
      .catch((err) => {
        let serverResponse = err;
        console.log(serverResponse);
        dispatch({
          type: KYC_DATA_FAILED,
          payload: serverResponse.data,
        });
      });
  };

  const saveKycInfo = async (tenantid, value) => {
    setLoading(true);
    await axiosInstance
      .patch(
        `${process.env.REACT_APP_SERVER_URL}/tenants/kyc/${tenantid}`,
        value,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        let serverResponse = res;
        dispatch({
          type: KYC_SUCCESS,
          payload: serverResponse,
        });
      })
      .catch((err) => {
        dispatch({
          type: KYC_FAILED,
          payload: err,
        });
        toast.error(_t("infoNotSaved"));
      });
    setLoading(false);
  };

  // const aliceKyc = (tenantid, value) => {
  //     return new Promise(async (resolve, reject) => {
  //         await axiosInstance.post(`${process.env.REACT_APP_SERVER_URL}/tenants/kyc/${tenantid}`, value, { headers: { "Accept-Language": localStorage.getItem('i18nextLng') } })
  //             .then(res => {
  //                 let serverResponse = res.data;
  //                 resolve(serverResponse);

  //             }).catch(err => {
  //                 reject(err);
  //             })
  //     })
  // }
  const onfidoKyc = (tenantid, value, queryParameters) => {
    return new Promise(async (resolve, reject) => {
      await axiosInstance
        .post(
          `${process.env.REACT_APP_SERVER_URL}/tenants/kyc/${tenantid}${queryParameters}`,
          value,
          {
            headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
          }
        )
        .then((res) => {
          let serverResponse = res.data;
          resolve(serverResponse);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const extTenantOnfidoKyc = (tenantid, value, queryParameters, userToken) => {
    return new Promise(async (resolve, reject) => {
      await axiosInstance
        .post(
          `${process.env.REACT_APP_SERVER_URL}/api/v1/tenants/kyc/${tenantid}${queryParameters}`,
          value,
          {
            headers: {
              "Accept-Language": localStorage.getItem("i18nextLng"),
              "x-modular-key": userToken,
            },
          }
        )
        .then((res) => {
          let serverResponse = res.data;
          resolve(serverResponse);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const getKycDocs = async (tenantid) => {
    const docs = await axiosInstance.get(
      `${process.env.REACT_APP_SERVER_URL}/tenants/get-document/${tenantid}`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          responseType: "blob",
        },
      }
    );
    return docs;
  };

  const getKycReport = async (tenantid) => {
    if (haveValue(tenantid)) {
      let myInterval = setInterval(async () => {
        await axiosInstance
          .get(
            `${process.env.REACT_APP_SERVER_URL}/tenants/getkycstatus/${tenantid}`,
            {
              headers: {
                "Accept-Language": localStorage.getItem("i18nextLng"),
              },
            }
          )
          .then((res) => {
            if (res.data.status === "success") {
              clearInterval(myInterval);
            }
          })
          .catch((err) => {
            console.log(err);
            clearInterval(myInterval);
          });
      }, 12000);
    }
  };

  const loadKycReport = async (tenantid) => {
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getkycreport/${tenantid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  };

  const getAccountAndBalances = async (tenantid, code) => {
    setLoading(true);
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/finance/${tenantid}/${code}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {})
      .catch((err) => {
        let serverResponse = err;
        console.log(serverResponse);
      });
  };

  const calculatePaymentScore = async (code, tenantid) => {
    setLoading(true);
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getaccinfo?code=${code}&tenantid=${tenantid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        let serverResponse = res;
        if (serverResponse.data.msg) {
          dispatch({
            type: PAYMENT_SCORE_FAILED,
            payload: serverResponse.data.msg,
          });
        }
        if (serverResponse.data.score) {
          toast.success(_t("skorCalculatedReturnToHomePage"));
          dispatch({
            type: PAYMENT_SCORE_SUCCESS,
            payload: serverResponse.data.score,
          });
        }
      })
      .catch((err) => {
        let err_res = err;
        toast.error(err_res.message);
        dispatch({
          type: PAYMENT_SCORE_FAILED,
          payload: err_res,
        });
      });
  };

  const clearPaymentData = async (tenantid) => {
    await axiosInstance
      .delete(
        `${process.env.REACT_APP_SERVER_URL}/tenants/algoan-info?tenantid=${tenantid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {})
      .catch((err) => {
        let err_res = err;
        toast.error(err_res.message);
      });
  };

  const shareProfile = async (
    tenantid,
    landlordid,
    sharedprofileid,
    profiletype,
    propertyPayload
  ) => {
    landlordid = landlordid.split("_");
    const check_res = await axiosInstance
      .post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/send-profile/${tenantid}/${landlordid[0]}/${sharedprofileid}?type=${profiletype}&workspaceId=${landlordid[1]}`,
        propertyPayload,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        if (localStorage.getItem("usertype") == "tenant") {
          loadSharedProfiles(tenantid, "full");
        }
        return res?.data;
      })
      .catch((err) => {
        if (err?.response?.data?.key === "guarantor-not-allowed") {
          return {
            success: false,
            key: "guarantor-not-allowed",
            msg: err?.response?.data?.msg,
          };
        } else if (err?.response?.data?.key === "workspace-not-found") {
          toast.error(_t("invitationLinkIsInvalid"));
          return;
        } else {
          return {
            success: false,
            key: err?.response?.data?.key || "general-error",
            msg: err?.response?.data?.error || "Unknown error",
            errormsg: err?.response?.data?.errormsg || "Unknown error",
          };
        }
      });
    if (check_res === true) return true;
    else return check_res;
  };

  const loadSharedProfiles = async (tenantid, profiletype) => {
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/shared-profile/myshared-profiles/${tenantid}?profiletype=${profiletype}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        let serverResponse = res.data;
        if (profiletype == "full") {
          dispatch({
            type: FULLSHARED_LOADED,
            payload: serverResponse,
          });
        }
        if (profiletype == "basic") {
          dispatch({
            type: BASICSHARED_LOADED,
            payload: serverResponse,
          });
        }
      });
  };

  const myRentedProperties = async (tenantid) => {
    if (haveValue(tenantid)) {
      await axiosInstance
        .get(
          `${process.env.REACT_APP_SERVER_URL}/properties/rentedproperties/${tenantid}`,
          {
            headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
          }
        )
        .then((res) => {
          dispatch({
            type: RENTED_PROPERTY_LOADED,
            payload: res.data.properties,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const myPreviouslyRentedProperties = async (tenantid) => {
    if (haveValue(tenantid)) {
      await axiosInstance
        .get(
          `${process.env.REACT_APP_SERVER_URL}/properties/previously-rented-properties/${tenantid}`,
          {
            headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
          }
        )
        .then((res) => {
          dispatch({
            type: PREVIOUS_RENTED_PROPERTY_LOADED,
            payload: res.data.properties,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const endLease = async (propertyid, tenantid) => {
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/properties/endlease/${propertyid}/${tenantid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        toast.success(res.data.msg);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getUniversityListing = async (search, loadedOptions) => {
    try {
      const result = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getUniversityListing/?search=${search}&offset=${loadedOptions.length}`
      );
      return result.data;
    } catch (err) {
      console.log("Error while fetching List", err);
    }
  };

  const linkGurantor = async (gurantor_id, tenant_id) => {
    const data = {
      gurantor_id,
      tenant_id,
    };
    const result = await axiosInstance.post(
      `${process.env.REACT_APP_SERVER_URL}/tenants/linkGurantor`,
      data,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
  };
  const linkGurantorAuto = async (gurantor_id, tenant_id) => {
    const data = {
      gurantor_id,
      tenant_id,
    };
    const result = await axiosInstance.post(
      `${process.env.REACT_APP_SERVER_URL}/users/linkGurantor/auto`,
      data,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
  };

  const guarantorDecline = async (gurantor_id, tenant_id) => {
    const data = {
      gurantor_id,
      tenant_id,
    };
    const result = await axiosInstance.post(
      `${process.env.REACT_APP_SERVER_URL}/tenants/guarantorDecline`,
      data,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
  };

  const removeGuarantor = async (gurantor_id) => {
    const data = {
      gurantor_id,
    };
    const result = await axiosInstance.post(
      `${process.env.REACT_APP_SERVER_URL}/tenants/removeGuarantor`,
      data,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    return result;
  };

  const rejectGuarantee = async (tenant_id) => {
    const data = {
      tenant_id,
    };
    const result = await axiosInstance.post(
      `${process.env.REACT_APP_SERVER_URL}/tenants/rejectGuarantee`,
      data,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    return result;
  };

  const updateDownloadedCheck = async (tenant_id) => {
    try {
      const data = {
        tenant_id,
      };
      const result = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/updateDownloaded`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return result;
    } catch (err) {
      console.log(err);
    }
  };

  const uploadFileData = async (
    filedata,
    llCreated = false,
    tenant_id = null,
    guarantor = false
  ) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/uploadDocument${
          llCreated ? `?llCreated=true&tenant_id=${tenant_id}` : ""
        }${guarantor ? `?guarantor=true&tenant_id=${tenant_id}` : ""}`,
        filedata,
        {
          headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
            "x-access-token": localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res;
    } catch (err) {
      toast.error(_t("errorInUploadingFile"));
    }
  };

  const submitProtectedHousingDocuments = async (payload) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/uploadProtectedHousingDocument`,
        payload,
        {
          headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
            "x-access-token": localStorage.getItem("token"),
          },
        }
      );
      return res;
    } catch (err) {
      toast.error(_t("errorSubmitting"));
    }
  };

  const submitReasonHandler = async (payload) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/addReason`,
        payload,
        {
          headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
            "x-access-token": localStorage.getItem("token"),
          },
        }
      );
      return res;
    } catch (err) {
      toast.error(_t("errorSubmittingReason"));
    }
  };

  const fetchTenantDocs = async (
    tenantId,
    llCreated = false,
    guarantor = false
  ) => {
    if (haveValue(tenantId)) {
      try {
        const res = await axiosInstance.get(
          `${
            process.env.REACT_APP_SERVER_URL
          }/tenants/getUploadedDocuments?tenantId=${tenantId}${
            llCreated ? "&llCreated=true" : ""
          }${guarantor ? "&guarantor=true" : ""}`,
          {},
          {
            headers: {
              "Accept-Language": localStorage.getItem("i18nextLng"),
              "x-access-token": localStorage.getItem("token"),
            },
          }
        );
        return res;
      } catch (err) {
        console.log(err);
      }
    }
  };

  const deleteTenantDoc = async (docId) => {
    try {
      const res = await axiosInstance.delete(
        `${process.env.REACT_APP_SERVER_URL}/tenants/deleteDoc?docId=${docId}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res;
    } catch (err) {
      toast.error(_t("unableToDeleteDocument"));
      return false;
    }
  };

  const skipVerification = async (tenantId) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/users/skipVerifications/${tenantId}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res;
    } catch (err) {
      toast.error(_t("unableToProcessRequest"));
      return false;
    }
  };

  const getPlaidLinkToken = async () => {
    try {
      const tenantId = localStorage.getItem("saveduserid");
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/initiatePlaid`,
        { tenantId },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorWhileInitialisingPlaidToken"));
      return false;
    }
  };

  const removeSharedProfile = async (sharedProfileId) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/removeSharedProfile`,
        { sharedProfileId },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorWhileRemovingSharedProfile"));
      return false;
    }
  };

  const acceptAssignedProp = async (formData, assignedPropId) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/accept/assigned/property/${assignedPropId}`,
        formData,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorWhileRemovingSharedProfile"));
      return false;
    }
  };

  const checkEmailInDeposit = async (email) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/check/email/deposit`,
        { email },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorWhileFetchingEmailDeposit"));
      return false;
    }
  };

  const checkLandlordExists = async (email) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/is/landlord/exists?email=${email}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return { exists: false };
    }
  };

  const sendRequestToLandlordToShareProfile = async (
    landlordEmail,
    applicationId
  ) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/shareProfileRequestToLandlord`,
        { landlordEmail, application_id: applicationId },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return (
        err?.response?.data ?? {
          success: false,
          message: "Failed to send share request.",
        }
      );
    }
  };

  const getTenantShareProfileRequestEntries = async () => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getTenantShareProfileRequests`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err?.response?.data ?? { success: false, data: [] };
    }
  };

  const cancelTenantShareProfileRequest = async (requestId) => {
    try {
      const res = await axiosInstance.delete(
        `${process.env.REACT_APP_SERVER_URL}/tenants/cancelTenantShareProfileRequest/${requestId}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return (
        err?.response?.data ?? {
          success: false,
          message: "Failed to cancel share request.",
        }
      );
    }
  };

  const joinWaitlist = async (email) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/users/joinWaitlist`,
        { email },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorWhileJoiningWaitlist"));
      return false;
    }
  };

  const getDocuSignURL = async (formData) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/docuSign`,
        formData,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorWhileGeneratingLink"));
      return false;
    }
  };

  const createDocConsent = async () => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/add-consent`,
        {},
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorWhileAddingConsent"));
      return false;
    }
  };

  const checkUelzStatus = async (assignedPropId) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/check/uelz/status/${assignedPropId}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  const uploadDepositProof = async (filedata) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/upload/deposit-proof`,
        filedata,
        {
          headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
            "x-access-token": localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res;
    } catch (err) {
      toast.error(_t("errorInUploadingFile"));
    }
  };

  const createUelzLedger = async (assignedPropertyId) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/uelz/ledger`,
        { assignedPropertyId },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorInInitiatingPayment"));
    }
  };

  const createTransactionLedger = async (formData) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/uelz/ledger`,
        formData,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorInInitiatingPayment"));
    }
  };

  const initiateInespay = async (assignedPropertyId) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/inititateInespay`,
        { assignedPropertyId },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      res.data.continue = true;
      return res.data;
    } catch (err) {
      toast.error(_t("errorInInitiatingPayment"));
      return { continue: false };
    }
  };

  const checkInespayStatus = async (assignedPropertyId) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/inespayStatus`,
        { assignedPropertyId },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      res.data.continue = true;
      return res.data;
    } catch (err) {
      toast.error(_t("errorInInitiatingPayment"));
      return { continue: false };
    }
  };

  const updateKyc = async (data) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/update/kyc`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorInUpdatingStatus"));
    }
  };

  const rentPayment = async (data) => {
    try {
      const res = await axiosInstance.post(
        // `${process.env.REACT_APP_SERVER_URL}/tenants/rent/payment`,
        `${process.env.REACT_APP_SERVER_URL}/tenants/rent/payment/truust`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorWhileGeneratingSession"));
    }
  };

  const rePayRent = async (data) => {
    try {
      const res = await axiosInstance.post(
        // `${process.env.REACT_APP_SERVER_URL}/tenants/repay/rent`,
        `${process.env.REACT_APP_SERVER_URL}/tenants/repay/rent/truust`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      toast.error(_t("errorWhileGeneratingSession"));
    }
  };

  const updateTenant = async (data, guarantor, user_id) => {
    try {
      const temp = {
        tenant_id: user_id ?? localStorage.getItem("saveduserid"),
        data,
      };
      if (guarantor) {
        temp.guarantor = guarantor;
      }
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/update/tenant/fields`,
        temp,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err, "Error in updating tenant fields");
    }
  };

  const getRentalInfo = async (tenant_id = null) => {
    try {
      if (!haveValue(tenant_id)) {
        tenant_id = localStorage.getItem("saveduserid");
      }
      const temp = {
        tenant_id,
      };
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/rental/info`,
        temp,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err, "Error in updating tenant fields");
    }
  };

  const ledgerData = async (tenant_id = null) => {
    try {
      if (!haveValue(tenant_id)) {
        tenant_id = localStorage.getItem("saveduserid");
      }
      const temp = {
        tenant_id,
      };
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/ledger/data`,
        temp,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err, "Error in updating tenant fields");
    }
  };

  const initiateBankFlip = async (
    type,
    llCreated = false,
    user_id = null,
    redirectSource,
    needWaitingJobForClave
  ) => {
    try {
      const temp = {
        tenant_id: haveValue(user_id)
          ? user_id
          : localStorage.getItem("saveduserid"),
        llCreated,
        type: type,
      };
      if (redirectSource) {
        temp.redirectSource = redirectSource;
      }
      if (needWaitingJobForClave) {
        temp.needWaitingJob = needWaitingJobForClave;
      }
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/initiate/bankflip`,
        temp,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err, "Error while initiating BankFlip");
    }
  };

  const fetchWaitingData = async (waitingId) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/users/waiting/data/${waitingId}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err, "Error while initiating BankFlip");
    }
  };

  const checkDuplicateDniNie = async (
    user_id,
    dni_nie,
    passport_id,
    guarantor
  ) => {
    try {
      const data = {
        user_id,
        dni_nie,
        passport_id,
        guarantor,
      };
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/check/dni-nie`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err, "Error while initiating BankFlip");
    }
  };

  const getDocumentAnalysis = async (user_id) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/download/document/report/${user_id}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err, "Error in getDocumentAnalysis");
    }
  };

  const getAgencyTenantLink = async (tenant_id) => {
    try {
      const data = {
        tenant_id,
      };
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/agency/tenant/shared`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      console.log(err, "Error in getAgencyTenantLink");
    }
  };

  const uploadBankStatement = async (filedata) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/upload/bankstatement`,
        filedata,
        {
          headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
            "x-access-token": localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res;
    } catch (err) {
      toast.error(_t("errorInUploadingFile"));
    }
  };

  const getZipDocs = async (tenantId, isGuarantor) => {
    let url = `${process.env.REACT_APP_SERVER_URL}/tenants/download/zip/docs/${tenantId}`;
    if (isGuarantor) {
      url += "?guarntor=true";
    }
    const docs = await axiosInstance.get(url, {
      headers: {
        "Accept-Language": localStorage.getItem("i18nextLng"),
        responseType: "blob",
      },
    });
    return docs;
  };

  const getZipOfMultipleTenantDocs = async (tenantIds) => {
    let url = `${process.env.REACT_APP_SERVER_URL}/tenants/download-multiple-zip-docs`;

    const docs = await axiosInstance.post(
      url,
      { tenantIds },
      {
        responseType: "blob", // ✅ correct place
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
        },
      }
    );

    return docs;
  };

  const createBasicGuarantorAccount = async (data) => {
    const res = await axiosInstance.post(
      `${process.env.REACT_APP_SERVER_URL}/tenants/create/basic/guarantor`,
      data,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    return res.data;
  };
  const updateBasicGuarantorAccount = async (data) => {
    const res = await axiosInstance.patch(
      `${process.env.REACT_APP_SERVER_URL}/tenants/create/basic/guarantor`,
      data,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    return res.data;
  };

  const guarantorAddedDetails = async (id) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/guarantor-added-details/${id}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return res.data;
    } catch (err) {
      return new Error("errorInside");
    }
  };

  const checkDocumentAnalysisStatus = async (tenant_id) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/checkDocumentAnalysisStatus?tenant_id=${tenant_id}`,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      return res.data;
    } catch (err) {
      console.error("Error checking document analysis:", err);
      return null;
    }
  };

  const upsertSelectedOnboardingUsers = async (payload) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/upsertSelectedOnboardingUsers`,
        payload,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      return res.data;
    } catch (err) {
      console.error("Error checking document analysis:", err);
      return null;
    }
  };

  const runForensic = async (email) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/runForensic?email=${email}`,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      return res.data;
    } catch (err) {
      console.error("Error checking document analysis:", err);
      return null;
    }
  };

  const deleteSelectedOnboardingUser = async (payload) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/deleteSelectedOnboardingUser`,
        payload,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      return res.data;
    } catch (err) {
      console.error("Error deleting user:", err);
      return null;
    }
  };

  const detectDocument = async (tenant_id) => {
    const res_data = await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/detectDoc?tenant_id=${tenant_id}`,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg ?? err.message);
      });
    return res_data;
  };

  const deleteDocument = async (docId, user_id) => {
    if (!docId || !user_id) {
      return;
    }
    const result = await axiosInstance.delete(
      `${process.env.REACT_APP_SERVER_URL}/tenants/document/delete?id=${docId}&user_id=${user_id}`,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    return result;
  };

  const getUserModuleData = async (public_id) => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getUserModules/${public_id}`,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      return res.data;
    } catch (err) {
      console.error("Error fetching module:", err);
      return null;
    }
  };

  const addSharer = async (payload) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/users/createSharer`,
        payload,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      return res.data;
    } catch (err) {
      return err;
    }
  };

  const shareProfileFromKelify = async (payload) => {
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/shareProfileFromKelify`,
        payload,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  };

  const updateSharerStatus = async (payload) => {
    try {
      const res = await axiosInstance.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/updateStatus`,
        payload,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      return res.data;
    } catch (err) {
      return err;
    }
  };

  const deleteSharer = async (sharerId) => {
    if (!sharerId) return;
    try {
      const res = await axiosInstance.delete(
        `${process.env.REACT_APP_SERVER_URL}/users/deleteSharer/${sharerId}`,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
      return res.data;
    } catch (err) {
      return err;
    }
  };

  const saveEffortRateData = async (data) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/saveEffortRateData`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const sendRemoteConnectLink = async (data) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/sendRemoteConnectLinkToGuarantor`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return response.data;
    } catch (err) {
      return err;
    }
  };

  const initiateModuleUserKyc = async (url, data) => {
    try {
      const response = await axios.get(url, {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          ...data?.headers,
        },
      });
      return response.data;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const submitConsents = async (data) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/submitConsents`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return response.data;
    } catch (err) {
      return err;
    }
  };

  const getLandlordsConsentInfo = async (requestProfileLink) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getLandlordsConsentInfo/${requestProfileLink}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return response.data;
    } catch (err) {
      return err;
    }
  };

  const deleteDuplicateDocuments = async (data) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/delete/duplicate/doc`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  const skipDuplicateDocument = async (data = {}) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/tenants/skip/duplicate/doc`,
        data,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  return (
    <TenantContext.Provider
      value={{
        kycuserinfo: state.kycuserinfo,
        fullProfileShared: state.fullProfileShared,
        fullProfileSharedLoaded: state.fullProfileSharedLoaded,
        basicProfileShared: state.basicProfileShared,
        rentedProperties: state.rentedProperties,
        previouslyRentedProperties: state.previouslyRentedProperties,
        loadingTenant: state.loadingTenant,
        isLoading: state.isLoading,
        isError: state.isError,
        kyc_done: state.kyc_done,
        paymentInfo: state.paymentInfo,
        paymentInfoError: state.paymentInfoError,
        demoFun,
        saveKycInfo,
        // aliceKyc,
        onfidoKyc,
        getKycInfo,
        getKycReport,
        loadKycReport,
        getAccountAndBalances,
        getKycDocs,
        calculatePaymentScore,
        clearPaymentData,
        shareProfile,
        setLoading,
        loadSharedProfiles,
        myRentedProperties,
        myPreviouslyRentedProperties,
        endLease,
        getUniversityListing,
        linkGurantor,
        removeGuarantor,
        updateDownloadedCheck,
        uploadFileData,
        fetchTenantDocs,
        deleteTenantDoc,
        skipVerification,
        getPlaidLinkToken,
        guarantorDecline,
        removeSharedProfile,
        acceptAssignedProp,
        checkEmailInDeposit,
        joinWaitlist,
        getDocuSignURL,
        checkUelzStatus,
        uploadDepositProof,
        createUelzLedger,
        initiateInespay,
        checkInespayStatus,
        updateKyc,
        rentPayment,
        updateTenant,
        getRentalInfo,
        rePayRent,
        ledgerData,
        createTransactionLedger,
        initiateBankFlip,
        fetchWaitingData,
        checkDuplicateDniNie,
        getDocumentAnalysis,
        getAgencyTenantLink,
        uploadBankStatement,
        submitReasonHandler,
        submitProtectedHousingDocuments,
        getZipDocs,
        createBasicGuarantorAccount,
        linkGurantorAuto,
        createDocConsent,
        guarantorAddedDetails,
        updateBasicGuarantorAccount,
        checkDocumentAnalysisStatus,
        upsertSelectedOnboardingUsers,
        rejectGuarantee,
        runForensic,
        deleteSelectedOnboardingUser,
        detectDocument,
        deleteDocument,
        getUserModuleData,
        addSharer,
        deleteSharer,
        updateSharerStatus,
        shareProfileFromKelify,
        saveEffortRateData,
        sendRemoteConnectLink,
        extTenantOnfidoKyc,
        initiateModuleUserKyc,
        submitConsents,
        getLandlordsConsentInfo,
        getZipOfMultipleTenantDocs,
        deleteDuplicateDocuments,
        skipDuplicateDocument,
        checkLandlordExists,
        sendRequestToLandlordToShareProfile,
        getTenantShareProfileRequestEntries,
        cancelTenantShareProfileRequest,
      }}
    >
      {props.children}
    </TenantContext.Provider>
  );
};

export default TenantState;
